
export default [
  {
    path: "/",
    name: "Bridge-home",
    component: () => import("@/views/RootHomeView")
  },
]